export default __webpack_public_path__ + "static/media/forget.b2aaf2e6.png";